module.exports = __webpack_public_path__ + "img/plus.2b33914c.svg";